/**
 * Created by avasilescu on 13-Aug-2018.
 */
import React, {Component} from 'react';

class IvrStepProgress extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const {progressCondition, completionCondition} = this.props;
        if (completionCondition) {
            return (<i className="material-icons green-text">&#xE876;</i>);
        } else if (progressCondition) {
            return (<div className="ivr-loader"></div>);
        }
        // default progress status is "queued" (3 dots)
        return (
            <div className="wait-path animate">
                <div className="wait-ball wait-ball1"></div>
                <div className="wait-ball wait-ball2"></div>
                <div className="wait-ball wait-ball3"></div>
            </div>);
    }
}

export default IvrStepProgress;